import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import configureStore from './redux/store'
import NetworkService from './network-service'
import { isFirebaseMessagingSupported } from './utils'
import firebaseConfig from './service/firebaseConfig'
import { messaging } from './service/firebase'

const store = configureStore()
NetworkService.setupInterceptors(store)

if ('serviceWorker' in navigator && isFirebaseMessagingSupported()) {
  console.log('register')
  const queries = []

  for (const prop in firebaseConfig) {
    queries.push(`${prop}=${firebaseConfig[prop]}`)
  }

  navigator.serviceWorker
    .register('./firebase-messaging-sw.js?' + queries.join('&'))
    .then(function (registration) {
      console.log('Registration successful, scope is:', registration.scope)
      messaging.useServiceWorker(registration)
    })
    .catch(function (err) {
      console.log('Service worker registration failed, error:', err)
    })
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister()
